export const faqCoverageExceptions: string[] = [];

export const FAQ_COUNTS_BY_ROUTE_FAMILY = {
  home: 5,
  static: 4,
  terms: 4,
  blog: 5,
  caseStudy: 6,
} as const;

export function getFaqRouteFamily(routePath: string) {
  const normalized = routePath.replace(/^\/+|\/+$/g, "");
  if (normalized === "") {
    return "home" as const;
  }

  if (normalized === "terms") {
    return "terms" as const;
  }

  if (normalized.startsWith("blog/") && normalized !== "blog") {
    return "blog" as const;
  }

  if (normalized.startsWith("case-studies/") && normalized !== "case-studies") {
    return "caseStudy" as const;
  }

  return "static" as const;
}

export function getExpectedFaqCountForRoutePath(routePath: string) {
  return FAQ_COUNTS_BY_ROUTE_FAMILY[getFaqRouteFamily(routePath)];
}
